import React from 'react';

import { theme as antTheme } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { NSKeys } from '@app/i18n';
import { useLocalSelector } from '@app/services/hooks/useRedux';
import { stringToBoolean } from '@app/services/stringToBoolean';
import { EpdTab } from '@components/EpdTab';

import { OrderTab } from './interfaces';
import { Container, Tabs as StyledTabs } from './styles';

interface IProps {
  orderUid: string;
  children: React.ReactNode;
}

export const OrderTabs: React.FC<IProps> = ({ orderUid, children }) => {
  const epdT = useTranslation(NSKeys.epd);
  const { token } = antTheme.useToken();
  const session = useLocalSelector((state) => state.currentSession);
  const [params, setParams] = useSearchParams();
  const epdEnabled =
    stringToBoolean(process.env.REACT_APP_FEATURE_EPD) &&
    !!session.ordersContext?.scope.$permissions.view_epd &&
    !session.data?.scope.is_sandbox;
  const activeKey = params.get('tab') === OrderTab.Epd && epdEnabled ? OrderTab.Epd : OrderTab.Details;
  if (!epdEnabled || !orderUid) return <>{children}</>;
  return (
    <StyledTabs
      activeKey={activeKey}
      destroyOnHidden
      onChange={(tab) =>
        setParams((current) => {
          const next = new URLSearchParams(current);
          next.set('tab', tab);
          return next;
        })
      }
      items={[
        { key: OrderTab.Details, label: epdT.t('orderDetails'), children },
        {
          key: OrderTab.Epd,
          label: epdT.t('title'),
          children: (
            <Container>
              <EpdTab orderUid={orderUid} />
            </Container>
          ),
        },
      ]}
      $colorBgBase={token.colorBgBase}
    />
  );
};
